<template>
  <div class="page-cases">
    <router-view v-if="$route.name.includes('.summary')" />

    <template v-else>
      <div class="w-100 row mb-3 filter-container mx-0">
        <div
          class="col-3 px-0 filter-items"
        >
          <div class="dropdown h-100">
            <button
              class="btn dropdown-toggle h-100 w-100 text-light"
              type="button"
              id="dropdownMenuButton"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <div class="w-100 h-100 d-flex">
                <div class="h-100 d-flex align-items-center">
                  <i class="fa fa-angle-down mx-2" aria-hidden="true"></i>
                </div>
                <div
                  class="text-start ms-2 d-flex flex-column align-items-start justify-content-center"
                >
                  <p class="mb-0">Agency</p>
                  <p class="fw-bold mb-0">
                    {{ selectedAgency || "All Agency" }}
                  </p>
                </div>
              </div>
            </button>
            <ul
              class="dropdown-menu bg-dark"
              aria-labelledby="dropdownMenuButton"
            >
              <li @click="selectedAgency = null">
                <button
                  class="dropdown-item text-light d-flex justify-content-between align-items-center"
                >
                  <span class="me-4">All Agency</span>
                  <i class="fas fa-check text-success" v-if="!selectedAgency" />
                </button>
              </li>
              <li
                v-for="agency in allAgencies"
                :key="agency"
                @click="selectedAgency = agency"
              >
                <button
                  class="dropdown-item text-light d-flex justify-content-between align-items-center"
                >
                  <span class="me-4">{{ agency }}</span>
                  <i
                    class="fas fa-check text-success"
                    v-if="selectedAgency == agency"
                  />
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div
        class="case-item justify-content-center text-secondary fst-italic"
        v-if="computedCases.length == 0"
      >
        No case found
      </div>
      <div class="row">
        <div
          class="col-6 p-2"
          v-for="pavement in computedCases"
          :key="`case-${pavement._id}`"
        >
          <div class="case-item mb-0 h-100">
            <div
              class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center mb-3 mb-sm-0"
            >
              <div class="flex-shrink-0 align-self-start">
                <div
                  class="case-image bg-light"
                  v-if="pavement.media && pavement.media.length"
                >
                  <img
                    :src="Helper.getCaseImage(pavement.media)"
                    v-if="Helper.getCaseImage(pavement.media)"
                    class="clickable"
                    @click="openMediaPreview(pavement.media)"
                  />
                </div>
              </div>
              <div class="flex-grow-1 ms-sm-3">
                <p class="fw-bold mb-0">
                  <span class="me-4"># {{ pavement.serialNo }}</span>
                </p>
                <p class="fw-bold mb-0">
                  {{ pavement.caption }}
                </p>
                <div class="pt-2 pb-3">
                  <span
                    class="badge bg-light text-dark px-3 me-2"
                    v-for="owner in pavement.owners"
                  >
                    {{ ownerName(owner) }}
                  </span>
                </div>
                <p class="small mb-0">
                  Start:
                  {{
                    Helper.formatDate(pavement.start_date, false)
                      ? Helper.formatDate(pavement.start_date, false)
                      : "Date not set"
                  }}, Completed:
                  {{
                    Helper.formatDate(pavement.end_date, false)
                      ? Helper.formatDate(pavement.end_date, false)
                      : "Date not set"
                  }}
                </p>

                <p
                  class="small mb-0 fs-bold d-flex justify-content-start align-items-center"
                  v-html="Helper.pavementRoadNames(pavement)"
                ></p>
              </div>
            </div>
            <div
              class="d-flex flex-column align-self-stretch justify-content-start"
            >
              <span
                :class="`text-${Helper.caseProgressColor(pavement.progress)}`"
                class="mb-4 text-nowrap fw-bold"
              >
                Progress {{ pavement.progress || "0" }}%
              </span>
              <router-link
                :to="{ name: 'pavement-details', params: { id: pavement._id } }"
                class="btn btn-sm btn-secondary rounded-pill text-nowrap px-3"
              >
                <i class="fa-solid fa-eye me-2" />
                View
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <media-viewer
        :url="currentMedia"
        v-if="currentMedia"
        @close="currentMedia = null"
      />
    </template>
  </div>
</template>

<script>
import MediaViewer from "@/components/MediaViewer";

export default {
  name: "page-cases",
  components: { MediaViewer },
  data() {
    return {
      pavementCases: [],
      currentMedia: null,
      allAgencies: ["PBT", "PDT", "JPS", "JKR"],
      selectedAgency: null,
      searchSerial: null,
    };
  },
  watch: {
    "$route.name": {
      handler() {
        this.getCases();
      },
      immediate: true,
    },
  },
  computed: {
    computedCases() {
      let _cases = JSON.parse(JSON.stringify(this.pavementCases));

      if (this.selectedAgency) {
        _cases = _cases.filter(
          (_case) =>
            _case.owners.map((owner) =>
              owner.split(owner?.includes(":") ? ":" : " ")[0].toLowerCase()
            ) == this.selectedAgency.toLowerCase()
        );
      }

      if (this.searchSerial) {
        _cases = _cases.filter((_case) =>
          _case.serialNo
            ?.toLowerCase()
            .includes(this.searchSerial.toLowerCase())
        );
      }

      return _cases;
    },
  },
  methods: {
    ownerName(fullName) {
      return fullName?.includes(":") ? fullName.split(":").pop() : fullName;
    },
    openMediaPreview(media) {
      if (!media || media.length == 0) return;

      this.currentMedia = this.Helper.getCaseImage(media);
    },
    getCases(keyword) {
      this.Helper.toggleLoadingSpinner(true);

      return new Promise(async (resolve, reject) => {
        let url = "pavement-cases?_sort=createdAt:desc&_limit=-1";

        if (keyword) {
          url += `&serialNo_contains=${keyword}`;
        }

        const [call, error] = await this.Helper.handlePromise(
          this.API.get(url)
        );

        if (error) {
          console.error(error);

          reject(error);
        } else {
          let _pavementCases = call.data.map((pavement) => {
            const owners =
              pavement.iraa_road
                ?.map((road) => road.attributes.owner)
                .filter((owner) => owner) || [];

            pavement.owners = [...new Set(owners)];

            return pavement;
          });

          this.pavementCases = _pavementCases;

          resolve();
        }

        this.Helper.toggleLoadingSpinner(false);
      });
    },
  },
};
</script>